import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

import { blockColumns } from './templates';

const INNER_BLOCKS_TEMPLATE = [
	blockColumns
];



const Edit = ( { probs } ) => {

	const showAttributes = JSON.stringify(probs);
	
	console.log('showAttributes'+showAttributes);

	const blockProps = useBlockProps();
	return (
		<div { ...blockProps }>
		<InnerBlocks
			template={ blockColumns }
			templateLock={ 'insert' }
			
			

		/>
		</div>
	)
};
export default Edit;
